export default __webpack_public_path__ + "static/media/Skyshear Girdle.a217c1d4.jpg";